<template>
  <router-view />
</template>

<script>
import gtmSnippetMixin from '@/mixins/gtmSnippet';
import zendeskSnippetMixin from '@/mixins/zendeskSnippet';
import adrollSnippetMixin from '@/mixins/adrollSnippet';
import toolkitMixin from '@/mixins/toolkit';
import sessionMixin from '@/mixins/session';

export default {
  name: 'app',
  mixins: [gtmSnippetMixin, zendeskSnippetMixin, adrollSnippetMixin, toolkitMixin, sessionMixin],
  mounted() {
    // get session id
    this.getSessionId();
    ['gesturestart', 'gesturechange', 'gestureend'].forEach(evt => {
      document.addEventListener(evt, e => e.preventDefault(), { passive: false });
    });

  }
};
</script>
<style>
html, body {
  touch-action: manipulation;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
}
</style>
